define('models/poll',['require','models/base/model'],function(require) {
    'use strict';

    var Model = require('models/base/model');

    var Poll = Model.extend({
        defaults: {
            caption: 'Опрос',
            description: 'Описание опроса',
            url: 'http://goo.gl',
            visible: false
        }
    });

    return Poll;
});
